/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { CalendarStrictHttpResponse } from '../../calendar-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SpecialitySearchResultModel } from '../../models/speciality-search-result-model';

export interface HealthFindrFhirIdSpecialitiesGet$Params {
  fhirId: string;
}

export function healthFindrFhirIdSpecialitiesGet(http: HttpClient, rootUrl: string, params: HealthFindrFhirIdSpecialitiesGet$Params, context?: HttpContext): Observable<CalendarStrictHttpResponse<SpecialitySearchResultModel>> {
  const rb = new RequestBuilder(rootUrl, healthFindrFhirIdSpecialitiesGet.PATH, 'get');
  if (params) {
    rb.path('fhirId', params.fhirId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as CalendarStrictHttpResponse<SpecialitySearchResultModel>;
    })
  );
}

healthFindrFhirIdSpecialitiesGet.PATH = '/HealthFindr/{fhirId}/Specialities';
